import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appAlphanumericLengthValidator]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: AlphanumericLengthValidatorDirective, multi: true }
  ]
})
export class AlphanumericLengthValidatorDirective implements Validator {
  @Input() minLength = 0;
  @Input() maxLength = Infinity;

  private static readonly ALPHANUMERIC_REGEX = /[^A-Z0-9]/gi;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const apenasAlfanumericos = input.value.replace(AlphanumericLengthValidatorDirective.ALPHANUMERIC_REGEX, '');
    if (apenasAlfanumericos.length > this.maxLength && isFinite(this.maxLength)) {
      event.preventDefault();
      event.stopPropagation();
      const valorAnterior = input.value.slice(0, -1);
      input.value = valorAnterior;
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
      nativeInputValueSetter?.call(input, valorAnterior);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const apenasAlfanumericos = String(control.value || '').replace(AlphanumericLengthValidatorDirective.ALPHANUMERIC_REGEX, '');
    this.clearPreviousValidations(control);

    if (apenasAlfanumericos.length < this.minLength) {
      return { minlength: { requiredLength: this.minLength, actualLength: apenasAlfanumericos.length } };
    }
    if (apenasAlfanumericos.length > this.maxLength) {
      return { maxlength: { requiredLength: this.maxLength, actualLength: apenasAlfanumericos.length } };
    }
    return null;
  }

  clearPreviousValidations(control: AbstractControl) {
    if (control.errors) {
      delete control.errors['minlength'];
      delete control.errors['maxlength'];
      if (Object.keys(control.errors).length === 0) {
        control.setErrors(null);
      }
    }
  }
}
